// removed by extract-text-webpack-plugin
module.exports = {"fieldsetRow":"_3b3Qo","fieldset":"r4ihE","fieldsetLabel":"_2E6-A","fieldsetInput":"SI6yv","fieldsetTextarea":"_3KqMC","uppercaseFieldsetLabel":"_2mXqJ","greenFieldsetLabel":"_37Zo4","fieldsetRadio":"_2OSHF","fieldsetCheckbox":"_243mV"};


//////////////////
// WEBPACK FOOTER
// ./client/sass/common.sass
// module id = 28
// module chunks = 0 1